/** MicExpand — your voice makes the live mark swell outward in realtime. */
import type { AffectModule } from '../../core/module-api';
import { cfgNum } from '../../core/module-api';
import { cloneShape } from '../../core/scene';
import { pathAnchors, transformPath } from '../../core/geometry';

const ICON =
  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M12 5V2"/><path d="M12 22v-3"/><path d="M5 12H2"/><path d="M22 12h-3"/></svg>';

export function createMicExpand(): AffectModule {
  return {
    manifest: {
      id: 'micexpand',
      kind: 'affect',
      name: 'Expand',
      apiVersion: 1,
      description: 'Your voice swells the live mark outward as you draw.',
      icon: ICON,
      capabilities: ['audio'],
      params: [{ kind: 'slider', key: 'amount', label: 'Amount', min: 0, max: 4, step: 0.1, default: 1.6 }],
    },

    affect(shapes, ctx) {
      const amt = cfgNum(ctx.config, 'amount', 1.6);
      const vol = ctx.audio?.volume ?? 0;
      const scale = 1 + vol * amt;
      if (scale === 1) return shapes.slice();
      return shapes.map((s) => {
        const anchors = pathAnchors(s.path);
        let cx = 0;
        let cy = 0;
        const n = Math.max(1, anchors.length);
        for (const p of anchors) {
          cx += p.x;
          cy += p.y;
        }
        cx /= n;
        cy /= n;
        const c = cloneShape(s);
        c.path = transformPath(s.path, (p) => ({ x: cx + (p.x - cx) * scale, y: cy + (p.y - cy) * scale }));
        return c;
      });
    },
  };
}
